const _ = require('lodash');

module.exports = function () {
    return function (text) {
        text = (`${text}` || '').toLowerCase().trim();
        return _.filter(text.split('\n'), maybeParagraph => maybeParagraph);
    };
};



// WEBPACK FOOTER //
// ./src/olycommon/filters/paragraphize.js